import React, { useEffect, useState, useRef } from "react";
import { Transition } from "react-transition-group";
import cx from "clsx";

import styles from "./text.module.scss";

const TextFromBottom = props => {
  const {
    delayMs = 220,
    durationMs = 720,
    visible: _visible,
    children,
    className,
    customAnimation
  } = props;

  const [visible, setVisible] = useState(false);
  const typeRef = useRef(null);
  const memoSetVisible = val => () => setVisible(val);

  useEffect(() => {
    setTimeout(memoSetVisible(_visible), 1);
  }, [_visible]); // eslint-disable-line

  return (
    <Transition in={visible} timeout={delayMs + durationMs}>
      {state => (
        <span className={styles.textWrap}>
          <span className={cx(styles.text, className, styles.proxy)}>
            {children}
          </span>
          <span
            ref={typeRef}
            className={cx(
              styles.fromBottom,
              styles[state],
              customAnimation && customAnimation(state),
              styles.text,
              className
            )}
            style={{
              transitionDelay: `${
                state === "entering" || state === "entered"
                  ? delayMs
                  : delayMs * 0.5
              }ms`
            }}
          >
            {children}
          </span>
        </span>
      )}
    </Transition>
  );
};

export default TextFromBottom;
